import { ViewportType } from '../../../enums';
export const PLANAR_PROJECTION_ID = 'planar';
